import {_serializeSingle, _serializeList} from '../core';
import type {ServerData} from '../core';

export function serializeDocumentAttachment(data: ServerData) {
    return _serializeSingle("documentAttachment", data);
}

export function serializeDocumentAttachmentList(data: ServerData) {
    return _serializeList("documentAttachment", data);
}
